import { http } from '@/lib'
import { Attachment } from '@/types/api'
import { FileObject } from '@clara/file-viewer'
import { useAsyncFn } from '@clara/hooks'
import { base64ToUint8Array } from '@clara/pdf-viewer'

const resolveBlob = ({
  fileType,
  content,
}: {
  fileType: string
  content: ArrayBuffer | string
}) => {
  if (fileType.includes('image')) {
    return base64ToUint8Array(content as string)
  }
  return content
}

export async function createAttachment(attachment: FileObject) {
  if (!attachment.content || !attachment.fileType) {
    console.error(attachment)
    throw new Error('Attachment content/fileType is required')
  }
  const { content, fileType } = attachment
  const blob = await resolveBlob({ content, fileType })

  const payload = new FormData()
  payload.append(
    'file',
    new Blob([blob], {
      type: attachment.fileType as string,
    }),
    attachment.name,
  )

  return http
    .post<Attachment[]>('/attachment', payload)
    .then((response) => response.data[0])
}

export function useCreateAttachment() {
  return useAsyncFn(async (attachment: FileObject) => {
    const response = await createAttachment(attachment)
    return response
  }, [])
}
